export default "__VITE_ASSET__B1nUO1Ks__"